import '.bq{position:relative;}.ssr-plugin'
import '.ib{width:64px;}.ssr-plugin'
import '.ic{height:64px;}.ssr-plugin'
import '.bz{flex-shrink:0;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.id{bottom:-4px;}.ssr-plugin'
import '.dh{right:-4px;}.ssr-plugin'
import '.cn{border-radius:50%;}.ssr-plugin'
import '.ie{border:2px solid var(--shades-white);}.ssr-plugin'
import '.ad{overflow:hidden;}.ssr-plugin'
import '.if{width:32px;}.ssr-plugin'
import '.ig{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bq ib ic bz"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="a6 id dh cn ie ad if ig"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
